module.exports = __webpack_public_path__ + "static/das-kapital-cc7724a5ece0802294beecca7329e868.jpg";